import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({ providedIn: 'root' })
export class UpdateService {
  constructor(private swUpdate: SwUpdate) {
    if (this.swUpdate.isEnabled) {
      // Check for updates immediately on load
      this.checkForUpdates();

      // Automatically update and reload if a new version is ready
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          console.log('New version found. Activating update...');
          this.activateUpdate();
        }
      });
    }
  }
  y;
  private checkForUpdates() {
    this.swUpdate
      .checkForUpdate()
      .then(() => console.log('Checked for updates'))
      .catch((err) => console.error('Error when checking for updates:', err));
  }

  private activateUpdate() {
    this.swUpdate.activateUpdate().then(() => {
      console.log('Update activated. Reloading...');
      window.location.reload();
    });
  }
}
